import { createSlice } from "@reduxjs/toolkit";
import { fetchDocumentsReducer } from "../../reducer/getDocument/fetchDocumentsReducer";

import i18n from "../../i18n";
const initialState = {
  data: [],
  isLoading: false,
  error: null,
};

const doctorDocumentsSlice = createSlice({
  name: "doctorDocuments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentsReducer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDocumentsReducer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchDocumentsReducer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || i18n.t("toast.failedToLoadDocuments");
      });
  },
});

export default doctorDocumentsSlice.reducer;
